import React from "react";
import EmailSubmissionForm from "./common/EmailSubmissionForm";
import styles from '../../../assets/styles/form.module.scss'

const Form = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.form_wrapper}>
          <div className={styles.explanation_wrapper}>
            <h1>My Redmine 無料お試し申し込み</h1>
            <p>My Redmineを最大2ヶ月無料でお試し頂けます（翌月末まで）。</p>
            <p>メールアドレスを入力してください。ご登録用URLを送信いたします。</p>
          </div>
          <EmailSubmissionForm styles={styles} redirectPath={'./complete'} />
        </div>
      </div>
      <div className={styles.global_edition_note}>
        所在地が日本国外である法人・個人の方は、全世界向けサービス <a href='https://www.redminecloud.net/' target='_blank' rel='noopener noreferrer'>My Redmine Global Edition</a> の無料お試しをご利用ください。
      </div>
    </div>
  );
};

export default Form;
